const message = {
  msg_1: '测试22',
}

export default message